<div class="flex flex-row justify-center items-center gap-2 p-4">
    <p>{{ primaryText() }}</p>
    <button 
        class="flex justify-center rounded p-2 dark:border dark:border-grey"
        (click)="switch()"
    >
        <ng-icon
            name="faSolidArrowsLeftRight" 
            size="16"
            color="#CC4A1E"
        ></ng-icon>
    </button>
    <p>{{ secondaryText() }}</p>
</div>
